import type { IAnswer, IQuestion } from "@/types/types";

export const createAnswersList = (
  questions: IQuestion[],
  answers: IAnswer[],
) => {
  return questions.map((question) => {
    const found = answers.find(
      (answer) => answer.questionId === question.questionId,
    );

    return found ? found : { questionId: question.questionId, empty: true };
  });
};
